var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkyeair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 56,
    viewBox: "0 0 230 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10762_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9904 20.2653L26.0297 21.5809C32.642 23.0239 34.3171 26.8011 34.3171 30.366C34.3171 35.8833 29.9971 40 21.2688 40C12.0997 40 8 35.5862 8 32.2759C8 30.5783 9.27839 29.3899 11.0417 29.3899C14.965 29.3899 13.9511 34.9072 21.2688 34.9072C25.0158 34.9072 27.0876 32.9125 27.0876 30.8753C27.0876 29.6446 26.4705 28.2865 24.0019 27.6923L15.8466 25.6976C9.27839 24.0849 8.08816 20.6048 8.08816 17.3369C8.08816 10.5464 14.6123 8 20.7398 8C26.3823 8 33.0387 11.0557 33.0387 15.13C33.0387 16.87 31.4959 17.8886 29.7326 17.8886C26.3823 17.8886 26.9995 13.3475 20.2549 13.3475C16.9046 13.3475 15.0532 14.8329 15.0532 16.9549C15.0532 19.0769 17.6981 19.756 19.9904 20.2653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0289 36.3501V11.6499C40.0289 9.57029 41.4395 8.16976 43.6436 8.16976C45.8477 8.16976 47.2584 9.57029 47.2584 11.6499V21.7507L58.6316 9.69761C59.4692 8.84881 60.2186 8.16976 61.497 8.16976C63.2162 8.16976 64.9354 9.18833 64.9354 10.9708C64.9354 12.0318 64.3623 12.7533 63.7452 13.3475L56.3393 20.8594L65.1117 33.7188C65.7729 34.695 66.4783 35.5862 66.4783 36.4775C66.4783 39.0663 64.4946 39.8302 62.7753 39.8302C61.3206 39.8302 60.5271 39.4907 59.5573 38.0053L51.2258 25.6127L47.2584 29.4324V36.3501C47.2584 38.4297 45.8477 39.8302 43.6436 39.8302C41.4395 39.8302 40.0289 38.4297 40.0289 36.3501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1713 36.3501V27.3528L68.3108 13.1777C67.9581 12.626 67.6936 11.9894 67.6936 11.3528C67.6936 8.97613 69.9418 8.16976 71.3525 8.16976C73.0717 8.16976 73.8651 8.84881 74.6145 10.2069L80.9183 21.3687L87.178 10.2069C88.0156 8.67905 88.809 8.16976 90.3078 8.16976C91.6303 8.16976 93.8785 8.97613 93.8785 11.3528C93.8785 11.9894 93.614 12.626 93.2614 13.1777L84.4008 27.3528V36.3501C84.4008 38.4297 82.9902 39.8302 80.7861 39.8302C78.5819 39.8302 77.1713 38.4297 77.1713 36.3501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2561 35.2042V12.7958C98.2561 9.69761 99.9312 8.72149 102.488 8.72149H119.46C121.576 8.72149 123.119 9.31565 123.119 11.5225C123.119 13.7294 121.576 14.3236 119.46 14.3236H105.486V20.9443H117.74C119.636 20.9443 121.135 21.4536 121.135 23.618C121.135 25.7825 119.636 26.2918 117.74 26.2918H105.486V33.6764H119.812C121.928 33.6764 123.471 34.2706 123.471 36.4775C123.471 38.6844 121.928 39.2785 119.812 39.2785H102.488C99.9312 39.2785 98.2561 38.3024 98.2561 35.2042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.365 34.1008L149.71 10.2918C150.328 8.72149 151.474 8.16976 153.237 8.16976H154.956C156.587 8.16976 158.042 8.55172 158.835 10.7162L167.564 34.1008C167.828 34.7798 168.269 36.0106 168.269 36.7745C168.269 38.4722 166.726 39.8302 164.875 39.8302C163.288 39.8302 162.142 39.2785 161.613 37.9204L159.761 32.8276H148.123L146.228 37.9204C145.743 39.2785 144.729 39.8302 143.01 39.8302C141.026 39.8302 139.66 38.6419 139.66 36.7745C139.66 36.0106 140.101 34.7798 140.365 34.1008ZM158.174 27.9894L154.075 15.7241H153.986L149.71 27.9894H158.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.457 36.3501V11.6499C172.457 9.57029 173.867 8.16976 176.071 8.16976C178.275 8.16976 179.686 9.57029 179.686 11.6499V36.3501C179.686 38.4297 178.275 39.8302 176.071 39.8302C173.867 39.8302 172.457 38.4297 172.457 36.3501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.845 36.3501V12.7958C186.845 9.69761 188.52 8.72149 191.077 8.72149H203.112C211.708 8.72149 214 13.2626 214 17.2095C214 20.5199 211.972 23.7878 208.534 24.5517V24.6366C212.237 25.1459 212.898 27.7348 212.898 30.8329C212.898 34.3554 213.868 35.6711 213.868 37.1141C213.868 38.7268 212.149 39.8302 210.473 39.8302C206.506 39.8302 206.197 36.1379 206.197 34.9072C206.197 29.5597 205.184 27.3952 201.216 27.3952H194.075V36.3501C194.075 38.4297 192.664 39.8302 190.46 39.8302C188.256 39.8302 186.845 38.4297 186.845 36.3501ZM194.075 14.069V22.3024H201.304C204.037 22.3024 206.771 21.6233 206.771 18.1857C206.771 14.9178 204.699 14.069 201.525 14.069H194.075Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10762_1164",
    x: 0,
    y: 0,
    width: 230,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10762_1164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10762_1164",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyeair1);
export default __webpack_public_path__ + "static/media/skyeair1.6fbb6d75df845511fac128fd602d92d9.svg";
export { ForwardRef as ReactComponent };